import { render } from "./fan2Direction.vue?vue&type=template&id=584002b2&scoped=true"
import script from "./fan2Direction.vue?vue&type=script&lang=js"
export * from "./fan2Direction.vue?vue&type=script&lang=js"

import "./fan2Direction.vue?vue&type=style&index=0&id=584002b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584002b2"]])

export default __exports__